import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Modal, Button, Checkbox } from "@mui/material";
import { toast } from "react-toastify";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import axios from "../api/constant";
import { Link } from 'react-router-dom';

import {
    subassets,
    getAssetsName,
    AddAsset,
    Assetnameinfo,
    AddHostelRequirement,
    getdistrictName,
    getallDistricts,
    getAmenitiesType,
    getdistictName,
    getAllBlocksFromDistrict,
    getGPFromDistrictAndBlock,
    getVillageFromGpBlockAndDistrict,
    getSchoolFromVillage,
    getAmenityCountsData,
    getHostelCategorySchoolWise,
    submitLimits,
    insertFyBudget,
} from "../api/Users";

const AllocatedAmenitiesLimits = ({ role, props, userData }) => {
    const { t } = useTranslation();
    const handleClick = (e) => {
        i18next.changeLanguage(e.target.value);
    };
    const navigate = useNavigate();


    const [open, setOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [type, setType] = useState("view");

    const [ExistAssetsType, setExistAssetsType] = useState([]);
    const [AssetsType, setAssetsType] = useState("");
    const [AssetsTypes, setAssetsTypes] = useState([]);
    const [DistrictData, setDistrictData] = useState([]);
    const [AssetsSubTypes, setAssetsSubTypes] = useState([]);
    const [CategoryHandle, setCategoryHandle] = useState([]);
    const [AssetSubtype, setAssetSubtype] = useState("");
    const [QuantityHandle, setQuantityHandle] = useState("");
    const [DisHandle, setDisHandle] = useState("");
    const [TentativeAmount, setTentativeAmount] = useState("");
    const [markRequired, setMarkRequired] = useState(true);
    const [ExistNameHandle, setExistNameHandle] = useState("");
    const [error, setError] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [District, setDistrict] = useState("");
    const [Villagecode, setVillagecode] = useState("");
    const [gm_id, setGm_id] = useState("");
    const [Role, setRole] = useState("");
    const [UDISE, setUDISE] = useState("");
    const [Block, setBlock] = useState("");
    const [GP, setGP] = useState("");
    const [SchoolName, setSchoolName] = useState("");
    const [schoolId, setSchoolId] = useState("");
    const [AllSchoolNames, setAllSchoolNames] = useState([]);
    const [postSchoolName, setPostSchoolname] = useState([]);
    const [Alldistricts, setAllDistricts] = useState([]);
    const [Allblocks, setAllBlocks] = useState([]);
    const [Allvillages, setAllVillages] = useState([]);
    const [AllVillagecode, setAllVillagecode] = useState([]);
    const [Allgm_id, setAllGm_id] = useState([]);
    const [AllGPs, setAllGPs] = useState([]);
    const [postAmenityName, setPostAmenityName] = useState("");
    const [postAmenitySubName, setPostAmenitySubName] = useState("");
    const [invalidQuantity, setInvalidQuantity] = useState(false);
    const [counts, setCounts] = useState({
        actual_count: 0,
        ideal_count: 0,
        shortage_count: 0,
    });
    const [enable, setEnable] = useState(false);
    const label = { inputProps: { "aria-label": "Urgent" } };
    const [checked, setChecked] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const [category, setCategory] = useState("");
    const [categories, setCategories] = useState([]);
    const [hostelType, setHostelType] = useState("");
    const [year, setYear] = useState("");
    const [srNo, setSrNo] = useState("");
    const [amount, setAmount] = useState(0);

    const handleChange = () => {
        setChecked(!checked);
    };

    useEffect(() => {
        getdistictName()
            .then((res) => {
                if (res.status === "success") {
                    console.log("dis data:", res.data);
                    setAllDistricts(res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching districts:", err);
            });
    }, []);

    const handleDistrictChange = (e) => {
        setDistrict(e.target.value);
        setAllBlocks([]);
        setAllGPs([]);
        setAllVillages([]);
        setAllSchoolNames([]);
        setSchoolName("");
        getAllBlocksFromDistrict(e.target.value)
            .then((res) => {
                if (res.status === "success") {
                    console.log("dis data:", res.data);
                    setAllBlocks(res.data.new_asset_query);
                }
            })
            .catch((err) => {
                console.error("Error fetching blocks:", err);
            });
    };

    const handleBlockChange = (e) => {
        setBlock(e.target.value);
        setAllGPs([]);
        setAllVillages([]);
        setAllSchoolNames([]);
        setSchoolName("");
        getGPFromDistrictAndBlock(District, e.target.value)
            .then((res) => {
                if (res.status === "success") {
                    console.log("dis data:", res.data);
                    setAllGPs(res.data.new_asset_query);
                }
            })
            .catch((err) => {
                console.error("Error fetching assets:", err);
            });
    };

    const handleGPChange = (e) => {
        setGP(e.target.value);
        setAllVillages([]);
        setAllSchoolNames([]);
        setSchoolName("");
        getVillageFromGpBlockAndDistrict(District, Block, e.target.value)
            .then((res) => {
                if (res.status === "success") {
                    console.log("dis data:", res.data);
                    setAllVillages(res.data.new_asset_query);
                }
            })
            .catch((err) => {
                console.error("Error fetching assets:", err);
            });
    };
    const handleVillageChange = (e) => {
        setVillagecode(e.target.value);
        setAllSchoolNames([]);
        setSchoolName("");
        getSchoolFromVillage(e.target.value)
            .then((res) => {
                if (res.status === "success") {
                    console.log("dis data:", res.data);
                    setAllSchoolNames(res.data.new_asset_query);
                }
            })
            .catch((err) => {
                console.error("Error fetching assets:", err);
            });
    };

    const handleSchoolName = async (e) => {
        const selectedSchool = JSON.parse(e.target.value);
        setSchoolId(selectedSchool.school_id);
        setSchoolName(selectedSchool.code);
        setPostSchoolname(selectedSchool.name);

        const postData = {
            UDISE_code: selectedSchool.code,
        };

        await axios
            .post("/get_hostel_category_school_wise", postData)
            .then((response) => {
                if (response.data.status == "success") {
                    console.log("get_hostel_category_school_wise :", response.data);
                    console.log(response.data.data.hostel_type);
                    setCategories(response.data.data.hostel_type);
                }
            })
            .catch((err) => {
                console.error("Error fetching Categories:", err);
            });
    };

    useEffect(() => {
        getAmenitiesType()
            .then((res) => {
                if (res.status === "success") {
                    console.log("amenities data:", res.data);
                    setAssetsTypes(res.data);
                    setExistAssetsType(res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching assets:", err);
            });

        getallDistricts()
            .then((res) => {
                if (res.status === "success") {
                    console.log("Assets data:", res.data);
                    setDistrictData(res.data);
                    // setExistAssetsType(res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching assets:", err);
            });
    }, []);

    const AssetTypehandle = async (e) => {
        const amenities = JSON.parse(e.target.value);
        console.log(amenities);
        setAssetsType(amenities.amenity_id);
        setPostAmenityName(amenities.name);
        console.log("AssetsType", AssetsType);
        try {
            const response = await subassets({ amenity_id: amenities.amenity_id });
            if (response) {
                console.log(response.data.asset_name);
                setAssetsSubTypes(response.data.asset_name);
                setShowTable(true);
            } else {
                console.error("Invalid response format for subassets:", response);
            }
        } catch (error) {
            console.error("Error fetching subassets:", error);
        }
    };

    const quantityHandle = (event) => {
        setQuantityHandle(event.target.value);
    };

    const disHandle = (event) => {
        setDisHandle(event.target.value);
    };
    const TentativeAmountHandle = (event) => {
        setTentativeAmount(event.target.value);
    };

    const AssetSubtypehandle = async (e) => {
        const amenities = JSON.parse(e.target.value);
        setAssetSubtype(amenities.amenity_sub_type_id);
        setPostAmenitySubName(amenities.name);

        const postData = {
            amenities_id: AssetsType,
            amenities_sub_type_id: amenities.amenity_sub_type_id,
            UDISE_code: SchoolName,
        };

        getAmenityCountsData(postData)
            .then((res) => {
                if (res.status === "success") {
                    console.log(res.data.result[0]);
                    setCounts({
                        actual_count:
                            res.data.result[0].actual_count === null
                                ? 0
                                : res.data.result[0].actual_count,
                        ideal_count:
                            res.data.result[0].ideal_count === null
                                ? 0
                                : res.data.result[0].ideal_count,
                        shortage_count:
                            res.data.result[0].shortage_count === null
                                ? 0
                                : res.data.result[0].shortage_count,
                    });
                    setEnable(true);
                }
            })
            .catch((err) => {
                console.error("Error fetching assets:", err);
            });
    };



    const [selectedRowData, setSelectedRowData] = useState([]);

    const handleRowDataChange = (index, event) => {
        const newData = [...selectedRowData];
        newData[index] = {
            sr_no: index + 1,
            amenities_sub_type_id: AssetsSubTypes[index]?.amenity_sub_type_id,
            amount: event.target.value,
        };
        setSelectedRowData(newData);
        console.log(newData);
    };

    const handleSubmitForm = async (event) => {
        event.preventDefault();

        const data = {
            financial_year: event.target.financial_year.value, 
            allocated_date: event.target.allocated_date.value, 
            allocated_fund: event.target.allocated_fund.value, 
        };

        insertFyBudget(data)
            .then((response) => {
                toast.success(response.message);
                // window.location.reload();
                setTimeout(() => {
                    navigate('/fy-budget-allocation');
                  }, 2000);
            })
            .catch((error) => {
                toast.error("Failed to insert FY budget");
            });
    };

    const handleCategory = (e) => {
        setCategory(e.target.value);
    };

    const handleHostelId = (e) => {
        setHostelType(e.target.value);
    };

    const handleClear = (e) => {

    }

    return (
        <>
            <TopLoader loading={isLoading ? "50" : "100"} />
            <div className="px-2 px-md-4">
                <h5 className="my-4">{t("FY Budget Allocation")}</h5>

                {role === 3 || role == 8 || role == 11 || role == 12 || role == 13? (
                    <form
                        onSubmit={(e) => handleSubmitForm(e)}
                        id="myform"
                        style={{ marginTop: "12px" }}
                    >
                        <div className="row">
                            {/*District */}
                            <div className="col-md-3">
                                <label className="form-label">
                                    {t("Financial year")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <select
                                    name="financial_year"
                                    className="common-input form-select"
                                    required
                                >
                                    <option value="">{t("Select Financial Year")}</option>
                                    <option value="2023-24">2023-24</option>
                                    <option value="2024-25">2024-25</option>
                                </select>
                            </div>

                            {/* DATE */}
                            <div className="col-md-3">
                                <label className="form-label">
                                    {t("Allocated Date")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <input type="date" name="allocated_date" className="common-input form-control" />
                            </div>

                               {/* Allocated Amount */}

                            <div className="col-md-3">
                                <label className="form-label">
                                    {t("Allocated Fund (in Rs.Cr)")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <input type="number" name="allocated_fund" className="common-input form-control" />
                            </div>

                            <div className="col-md-4"></div>
                            <div className="row" style={{ marginTop: "12px" }}></div>
                            <div className="col-md-4"></div>
                            <div className="col-md-4"></div>
                        </div>
                        <div
                            className="row col-12 d-flex justify-content-center"
                            style={{ marginTop: "12px" }}
                        >
                            <div
                                className="col-md-10 justify-content-center"
                                style={{ display: showTable == true ? "flex" : "none" }}
                            >
                                <TableContainer
                                    component={Paper}
                                    style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
                                    className="my-4"
                                >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 40 }} align="center">
                                                    {t("Sr No.")}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {t("Amenity Sub-type")}
                                                </TableCell>
                                                <TableCell style={{ width: 40 }} align="center">
                                                    {t("Limit/Amt")}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody style={{ color: "white" }}>
                                            {AssetsSubTypes.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell style={{ width: 100 }} align="center">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell style={{ width: 100 }} align="left">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        className="d-flex justify-content-center"
                                                    >
                                                        <input
                                                            type="number"
                                                            style={{ width: 200 }}
                                                            value={selectedRowData[index]?.amount || ""}
                                                            onChange={(e) => handleRowDataChange(index, e)}
                                                            className="form-control"
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "-60px" }}></div>
                        <div className="row mt-sm-2 mt-md-5 mb-sm-4">
                            <div className="col-md-8"></div>
                            <div className="col-md-4 d-flex justify-content-end">
                                <button type="submit" className="btn btn-primary me-2">
                                    {t("Submit")}
                                </button>
                                <Link to="/fy-budget-allocation">
                                    <button type="button" className="btn btn-danger me-2">
                                        {t("Back")}
                                    </button>
                                </Link>
                                {/* <button type="button" className="btn btn-secondary">
                  {t("Clear")}
                </button> */}
                            </div>
                        </div>
                    </form>
                ) : (
                    <form
                        // onSubmit={(e) => handleSubmitForm(e)}
                        id="myform"
                        style={{ marginTop: "12px" }}
                    >
                        <div className="row" style={{ marginTop: "12px" }}>
                            <div className="col-md-4">
                                <label className="form-label">
                                    {t("Amenity Type")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <select
                                    name="asset_type_id"
                                    className="common-input form-select"
                                    onChange={AssetTypehandle}
                                    required
                                >
                                    <option value="">{t("Select Amenity Type")}</option>
                                    {/* Map assetOptions to generate option elements */}
                                    {AssetsTypes.assets_name &&
                                        AssetsTypes.assets_name.map((row, index) => (
                                            <option key={index} value={JSON.stringify(row)}>
                                                {row.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    {t("Amenity Sub Type")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <select
                                    name="asset_sub_type_id"
                                    onChange={AssetSubtypehandle}
                                    className="common-input form-select"
                                    required
                                >
                                    <option value="">{t("Select Amenity Sub Type")}</option>

                                    {AssetsSubTypes &&
                                        AssetsSubTypes.map((row, index) => (
                                            <option key={index} value={JSON.stringify(row)}>
                                                {row.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    {t("Quantity")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <input
                                    type="text"
                                    name="asset_quantity"
                                    value={QuantityHandle}
                                    className="form-control"
                                    onChange={quantityHandle}
                                    required
                                    disabled={!enable}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "12px" }}>
                            <div className="col-md-4">
                                <label className="form-label">
                                    {t("Tentative Amount")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <input
                                    type="text"
                                    name="tentative_amount"
                                    value={TentativeAmount}
                                    className="form-control"
                                    onChange={TentativeAmountHandle}
                                    required
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    {t("School")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <input
                                    type="text"
                                    disabled
                                    name="school"
                                    value={userData.data.name}
                                    className="form-control"
                                    // onChange={TentativeAmountHandle}
                                    required
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    {t("UDISE code")}{" "}
                                    {markRequired && <span style={{ color: "red" }}>*</span>}
                                </label>
                                <input
                                    type="text"
                                    disabled
                                    name="udise_code"
                                    value={userData.data.UDISE_code}
                                    className="form-control"
                                    // onChange={TentativeAmountHandle}
                                    required
                                />
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "-100px" }}>
                            <div className="col-md-4">
                                <label className="form-label m-2">
                                    Mark as an <span className="fw-bold">Urgent Requirement</span>
                                </label>
                                <input
                                    className="m-2 largerCheckbox form-check-input"
                                    type="checkbox"
                                    checked={checked}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="row mt-sm-2 mt-md-5 mb-sm-4">
                            <div className="col-md-8"></div>
                            <div className="col-md-4 d-flex justify-content-end">
                                <button type="submit" className="btn btn-primary me-2">
                                    {t("Submit")}
                                </button>
                                {/* <button type="button" className="btn btn-secondary" onClick={handleClear}>
                  {t("Clear")}
                </button> */}
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </>
    );
};

export default AllocatedAmenitiesLimits;
